import gql from 'graphql-tag';

export const LIST_PAGES_QUERY = gql`
  query ListPages(
    $first: Int
    $last: Int
    $after: Cursor
    $before: Cursor
    $query: String
  ) {
    pages(
      first: $first
      last: $last
      after: $after
      before: $before
      query: $query
    ) @connection(key: "pages") {
      edges {
        node {
          id
          title
          path
          publishAt
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;
